import React from "react";
import { Link } from "react-router-dom";
import { User } from "lucide-react";

/** The same minimal public navbar used by the homepage. */
export default function PublicNavbar() {
  return (
    <header className="relative z-30 border-b border-white/10 bg-[#071322] text-white">
      <div className="mx-auto flex h-[76px] w-full max-w-[1280px] items-center justify-between gap-4 px-4 sm:px-8 lg:px-9">
        <Link to="/" aria-label="Find Auto Parts home" className="flex shrink-0 items-center">
          <img
            src="/logo white.png"
            alt="Find Auto Parts"
            className="h-[70px] w-[155px] object-contain sm:w-[195px]"
          />
        </Link>
        <Link
          to="/user/login"
          className="flex shrink-0 items-center justify-center gap-2 rounded-lg border border-white/30 bg-white/10 px-4 py-2.5 text-sm font-semibold text-white transition hover:border-[#ff313b] hover:bg-white/20 sm:px-5"
        >
          <User size={18} /> Login
        </Link>
      </div>
    </header>
  );
}
